module.exports = __webpack_public_path__ + "img/get-directions-arrow.03e9ddc9.png";